module.exports = __webpack_public_path__ + "img/11b87d8.jpg";